import { component } from 'picoapp';

export default component((node) => {
	let animationTimeoutId = null;
	let mouseIsOverButton = false;
	const isDesktopUser = window.innerWidth > 767;
	const fixedButtonTrigger = document.querySelectorAll(
		`.js-${isDesktopUser ? 'desktop' : 'mobile'}-fixed-trigger`
	);

	const triggerButtonState = (state) => {
		node
			.querySelectorAll('[aria-expanded]')
			.forEach((element) => (element.ariaExpanded = state));
	};

	const cancelTimeout = () => {
		if (animationTimeoutId) {
			clearTimeout(animationTimeoutId);
			animationTimeoutId = null;
		}
	};

	const startTimeout = () => {
		cancelTimeout();
		animationTimeoutId = setTimeout(() => {
			node.style.animation = 'none';
			node.offsetHeight;
			node.style.animation = 'bounce 1.5s ease-in 1s';
		}, 6500);
	};

	const handleMouseEvent = (e) => {
		mouseIsOverButton = e?.type === 'mouseenter';
		cancelTimeout();
		triggerButtonState(`${mouseIsOverButton ? true : false}`);
		if (mouseIsOverButton) {
			sendTrackingEvents('Fixed AR Button Hover', {
				event_detail: node.dataset.eventDetail,
			});
		}
		if (!mouseIsOverButton) startTimeout();
	};

	const handleAnimationEnd = (e) => {
		if (e.animationName === 'bounce' && !mouseIsOverButton) {
			triggerButtonState('false');
			startTimeout();
		}
	};

	const setupObserver = (element, threshold = 0.1, margin = '0px') => {
		const observerOptions = {
			rootMargin: margin,
			threshold: parseFloat(threshold),
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					node.ariaHidden = 'true';
					triggerButtonState('true');
					cancelTimeout();
				} else if ((!isDesktopUser && window.scrollY > 1000) || isDesktopUser) {
					node.ariaHidden = 'false';
				}
			});
		}, observerOptions);

		observer.observe(element);
	};

	fixedButtonTrigger.forEach((trigger) => setupObserver(trigger));

	node.addEventListener('mouseenter', handleMouseEvent);
	node.addEventListener('mouseleave', handleMouseEvent);
	node.addEventListener('animationend', handleAnimationEnd);

	return () => {
		node.removeEventListener('mouseenter', handleMouseEvent);
		node.removeEventListener('mouseleave', handleMouseEvent);
		node.removeEventListener('animationend', handleAnimationEnd);
	};
});
